import { render, staticRenderFns } from "./OrdersProductsTable.vue?vue&type=template&id=5fd345ea&"
import script from "./OrdersProductsTable.vue?vue&type=script&lang=js&"
export * from "./OrdersProductsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports